import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id                : 0,
        sender_name               : '',
        sender_email              : '',
        app_logo                  : '',
        email_logo                : '',
        display_powered_by        : true,
        favicon                   : '',
        colour                    : '',
        is_sender_email_confirmed : false
    }
});